import { isDefined } from "@clipboard-health/util-ts";
import { showErrorToast } from "@src/appV2/lib/Notifications";
// eslint-disable-next-line no-restricted-imports -- Bridge to old app code
import { signInWithEmailAndPassword } from "@src/containers/enter/firebase";
// eslint-disable-next-line no-restricted-imports -- Bridge to old app code
import { getErrorMessage } from "@src/utils/errors";
import { FirebaseAuth } from "@src/utils/firebase";
import { establishCognitoSessionFromFirebaseToken } from "@src/appV2/Auth/cognito/firebaseTokenExchange";
import { APP_V2_APP_EVENTS, logError, logEvent } from "@src/appV2/lib/analytics";

interface LoginWithEmailAndPasswordParams {
  email: string;
  password: string;
}

/**
 * Handles Firebase email/password authentication for mobile
 * This keeps the mobile component clean and isolated
 */
export async function loginWithEmailAndPassword({
  email,
  password,
}: LoginWithEmailAndPasswordParams): Promise<boolean> {
  try {
    const result = await signInWithEmailAndPassword(email, password);
    if ("error" in result && typeof result.error === "string") {
      showErrorToast(result.error);
      return false;
    }

    try {
      const firebaseIdToken = await FirebaseAuth.currentUser?.getIdToken();
      if (isDefined(firebaseIdToken)) {
        await establishCognitoSessionFromFirebaseToken({
          email,
          firebaseIdToken,
        });
        logEvent(APP_V2_APP_EVENTS.PASSWORD_LOGIN_COGNITO_SESSION_SUCCESS);
      }
    } catch (cognitoError: unknown) {
      // Cognito session is best-effort; do not block the user.
      logError(APP_V2_APP_EVENTS.PASSWORD_LOGIN_COGNITO_SESSION_FAILURE, {
        error: cognitoError,
      });
    }

    return true;
  } catch (error: unknown) {
    const message = String(getErrorMessage(error));
    showErrorToast(message);
    return false;
  }
}
